import { Tabs } from "@components";
import styles from "@styles/containers/cdp/audiences.module.scss";
import { useEffect, useState } from "react";
import { ForEach, If } from "shared/components/control-statements";
import { AudienceTableItem } from "./AudienceTableItem";
import { AudienceHistory } from "./history/AudienceHistory";
import { UserStorage } from "shared/tools/UserStorage";

export const AudiencesTable = ({ audiences, archived, onSelect, onChange, selectedAudience }) => {
  const [selected_audience, setSelectedAudience] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [openHistory, setOpenHistory] = useState(false);
  const [collapsed, setCollapsed] = useState(null);

  useEffect(() => {
    if (selectedAudience) 
      setSelectedAudience(selectedAudience);
  }, [selectedAudience])

  const savedAudiences =
    audiences.filter(
      (a) =>
        !a.name?.trimStart().startsWith("[Olga] ") &&
        !a.name?.trimStart().toLowerCase().startsWith("[bloqueado] ")
    ) || [];
  const suggestedAudiences =
    audiences.filter(
      (a) =>
        (
          a.name?.trimStart().startsWith("[Olga] ") ||
          a.name?.trimStart().toLowerCase().startsWith("[bloqueado] ")
        ) && (
          UserStorage.isGodMode || 
          a.state != 'HIDDEN'
        )
    ) || [];

  const tabs = {
    ALL: {
      key: "ALL",
      name: `Todos (${audiences.length})`,
    },
    SAVED: {
      key: "SAVED",
      name: `Meus públicos (${savedAudiences.length})`,
    },
    SUGGESTED: {
      key: "SUGGESTED",
      name: `Públicos sugeridos (${suggestedAudiences.length})`,
    },
  };

  useEffect(() => {
    setActiveTab(tabs.ALL.key);
  }, [tabs.ALL.key]);

  const onFilterAudiences = () => {
    switch (activeTab) {
      case tabs.ALL.key:
        return audiences;
      case tabs.SAVED.key:
        return savedAudiences;
      case tabs.SUGGESTED.key:
        return suggestedAudiences;
      default:
        return [];
    }
  };

  const filteredAudiences = onFilterAudiences();

  return (
    <div className={styles.audiencesContainer}>
      {!archived && (
        <Tabs
          tabs={Object.values(tabs)}
          activeTab={activeTab}
          onTabSelected={(tab) => setActiveTab(tab)}
        />
      )}

      <If cond={audiences.length > 0}>
        <div className={styles.table}>
          <table>
            <tbody>
              <tr>
                <th>Nome do público</th>
                {/* <th>Status</th> */}
                <th>Tipo do público</th>
                <th>Qtd. Clientes</th>
                <th>Crescimento</th>
                <th />
              </tr>
              <tr className={styles.spacer}>
                <td colSpan="6"></td>
              </tr>

              <ForEach
                items={filteredAudiences}
                render={(audience) => (
                  <AudienceTableItem
                    audience={audience}
                    onSelect={() => onSelect(audience)}
                    onSaved={onChange}
                    onDeleted={onChange}
                    selectedAudience={selected_audience}
                    onOpenHistory={(audience) => {
                      setOpenHistory(true);
                      setSelectedAudience(audience);
                    }}
                    archived={archived}
                    collapsed={collapsed}
                    setCollapsed={(a) => setCollapsed(a)}
                  />
                )}
              />
            </tbody>
          </table>
        </div>
      </If>

      <If cond={audiences.length === 0}>
        <div className={styles.empty}>
          <div className={styles.icon}>
            <i className="fal fa-users" />
          </div>
          <p>Não há públicos {archived ? "arquivados" : "salvos"}.</p>
          <span>
            Por meio desta ferramenta, será possível visualizar os públicos{" "}
            {archived ? "arquivados" : "salvos"}.
          </span>
        </div>
      </If>

      {selected_audience && (
        <AudienceHistory
          visible={openHistory}
          onClose={() => setOpenHistory(false)}
          audience={selected_audience}
        />
      )}
    </div>
  );
};
